// Parallax effect calculation
function parallaxEffect(layer, element, distance, speed) {
  const yOffset = window.pageYOffset;
  const elementOffsetTop = element.offsetTop;
  const elementHeight = element.offsetHeight;
  const viewportHeight = window.innerHeight;

  // Check if the element is within the viewport
  if (yOffset + viewportHeight > elementOffsetTop && yOffset < elementOffsetTop + elementHeight) {
    const position = (yOffset - elementOffsetTop + viewportHeight) * -speed;
    const transform = `translate3d(0, ${position}px, 0)`;
    layer.style.transform = transform;
  }
}

// Parallax initialization
function initializeParallax() {
  const parallaxLayers = document.querySelectorAll('.parallax__layer');

  // Add parallax effect to each layer
  parallaxLayers.forEach((layer) => {
    const speed = parseFloat(layer.getAttribute('data-speed'));
    const section = layer.closest('.parallax'); // Find the parent section element

    parallaxEffect(layer, section, window.pageYOffset, speed);

    window.addEventListener('scroll', () => {
      parallaxEffect(layer, section, window.pageYOffset, speed);
    });
  });
}

// Update from DY content
function updateParallaxContent() {
  //define elements to update
  const context = window.Brooklinen?.parallax[0].config,
    parallaxHeader = document.querySelector(`#${context.id} .h_1`),
    parallaxSubtext = document.querySelector(`#${context.id} .p_1`),
    parallaxBgDesktop = document.querySelector(`#${context.id} .parallax__background-desktop`),
    parallaxBgMobile = document.querySelector(`#${context.id} .parallax__background-mobile`);

  //update elements
  parallaxHeader.innerHTML = context?.header;
  parallaxHeader.style.color = context?.headerColor;
  parallaxSubtext.innerHTML = context?.subtext;
  parallaxSubtext.style.color = context?.headerColor;
  parallaxBgDesktop.setAttribute('src', context?.bgDesktop);
  parallaxBgMobile.setAttribute('src', context?.bgMobile);
}
export default function mountParallax() {
  document.addEventListener('dy:module:parallax', updateParallaxContent);
  // Initialize parallax on window load
  window.addEventListener('load', initializeParallax);
}
